import * as React from 'react'

import { CONTEXT_MENU_PANEL_WIDTH_PX } from '@/lib/editor/context-menu-viewport'

export const ContextMenuPanel = React.forwardRef<
  HTMLDivElement,
  { left: number; top: number; maxHeight?: number; children: React.ReactNode }
>(({ left, top, maxHeight, children }, ref) => {
  return (
    <div
      ref={ref}
      role="menu"
      className="absolute z-50 overflow-x-hidden overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95"
      style={{
        left,
        top,
        width: `${CONTEXT_MENU_PANEL_WIDTH_PX}px`,
        maxHeight: maxHeight !== undefined ? maxHeight : undefined,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  )
})

ContextMenuPanel.displayName = 'ContextMenuPanel'
